"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24VehicleWalk = function Svg24VehicleWalk(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M13.5 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM10.579 10.1l-1.815.682-.836 2.078a1 1 0 0 1-1.856-.746l.836-2.079A2 2 0 0 1 8.06 8.91L11 7.807a2 2 0 0 1 2.21.558l1.766 2.027 2.461 1.196a1 1 0 0 1-.874 1.799l-2.46-1.196a1.998 1.998 0 0 1-.634-.485l-.953-1.092-.84 2.518 3.093 2.32a2 2 0 0 1 .78 1.317l.441 3.09a1 1 0 0 1-1.98.282l-.441-3.09-3.092-2.318a2 2 0 0 1-.698-2.233l.8-2.4z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M9.816 15.551a1 1 0 0 1 .633 1.265l-.617 1.851-2.817 1.69a1 1 0 0 1-1.03-1.715l2.183-1.31.383-1.148a1 1 0 0 1 1.265-.633z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24VehicleWalk.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24VehicleWalk;
exports.default = _default;